import axios from "axios";


function saveQuyen(role,list){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/admin/quyentruycap/savequyen?role="+role,list);
};
const quyenTruyCapAdminService={

  saveQuyen
};

export default quyenTruyCapAdminService;
